// app-user · template layer (app-user/src/ui) — the few strings a template owns itself:
// default accessible names for its built-in controls (close ×, clear, stepper −/+, toast
// dismiss) and state words read out by screen readers. Screens pass their own copy for
// everything visible. Spread into en.ts / bn.ts.
export const appEnUi = {
  'app.ui.close': 'Close',
  'app.ui.back': 'Back',
  'app.ui.clearText': 'Clear text',
  'app.ui.decrease': 'Decrease {label}',
  'app.ui.increase': 'Increase {label}',
  'app.ui.dismiss': 'Dismiss',
  'app.ui.remove': 'Remove',
  'app.ui.locked': 'Locked',
  'app.ui.loading': 'Loading',
  'app.ui.otpCode': 'Enter the 6-digit code',
  'app.ui.badgeCount': '{n} new',
  'app.ui.step.done': 'done',
  'app.ui.step.current': 'in progress',
  'app.ui.step.problem': 'problem',
  'app.ui.step.todo': 'not yet',
  'app.ui.stepOf': 'Step {n} of {total}',
} as const satisfies Record<string, string>;

export const appBnUi = {
  'app.ui.close': 'বন্ধ করুন',
  'app.ui.back': 'পেছনে',
  'app.ui.clearText': 'লেখা মুছুন',
  'app.ui.decrease': '{label} কমান',
  'app.ui.increase': '{label} বাড়ান',
  'app.ui.dismiss': 'সরিয়ে দিন',
  'app.ui.remove': 'সরিয়ে দিন',
  'app.ui.locked': 'লক করা',
  'app.ui.loading': 'লোড হচ্ছে',
  'app.ui.otpCode': '৬ সংখ্যার কোড দিন',
  'app.ui.badgeCount': '{n}টি নতুন',
  'app.ui.step.done': 'সম্পন্ন',
  'app.ui.step.current': 'চলছে',
  'app.ui.step.problem': 'সমস্যা',
  'app.ui.step.todo': 'এখনও হয়নি',
  'app.ui.stepOf': 'ধাপ {n}/{total}',
} as const satisfies Record<string, string>;
